var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tc-table',{staticClass:"tc-table mt-5",attrs:{"dataList":_vm.visits,"tbody":_vm.tbody,"settings":{
      export: {
        show: true,
        handle: _vm.exportCsv
      },
      filters: {
        contactType: {
          type: 'v-select',
          class: 'min-w-48',
          label: 'Type',
          clearable: false,
          options: {
            text: 'name',
            value: 'id',
            items: [{
              id: '',
              name: 'All'
            } ].concat( ((_vm.contactTypes || {}).items || []))
          }
        }
      }
    }},on:{"filter":_vm.fetchDataWithFiltering}},[_c('template',{slot:"thead"},[_c('vs-th',[_vm._v("Status")]),_c('vs-th',[_vm._v("Location")]),_c('vs-th',[_vm._v("Name")]),_c('vs-th',[_vm._v("Type")]),_c('vs-th',[_vm._v("Company")]),_c('vs-th',[_vm._v("Hosted By")]),_c('vs-th',[_vm._v("Sign in")]),_c('vs-th',[_vm._v("Sign out")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }